import { MagazineNode, PaginaNode } from '@gql/graphql'
import {
  ArticoliSection,
  GenericHero,
  Carousel,
  ImageWithChips,
  ProdottiSection,
  Page,
  Prefooter,
} from 'components/organisms'
import { useTrans } from 'hooks'
import { Button, EditableVideo, WContainer } from '../../atoms'
import styles from './MagazineDetailTemplate.module.sass'

interface Props {
  pagina?: PaginaNode
  magazine?: MagazineNode
}

const MagazineDetailTemplate = (props: Props) => {
  const { pagina = undefined, magazine = undefined } = props

  const t = useTrans()

  return (
    <Page pagina={pagina} className={`${styles.root}`}>
      <main>
        <GenericHero
          pagina={{
            ...pagina,
            titolo: magazine?.title,
          }}
        />
        <div className={styles.container}>
          <ImageWithChips
            item={{
              image: magazine.imageUrl,
              imageAlt: magazine.imageAlt,
            }}
            chips={[magazine.tag]}
            date={magazine.pubDate}
          />
          {!!magazine.descriptionHead && (
            <WContainer variant="sm">
              <div className={styles.content}>
                {!!magazine.descriptionHead && (
                  <div
                    className={styles.description}
                    dangerouslySetInnerHTML={{ __html: magazine.descriptionHead }}
                  />
                )}
              </div>
            </WContainer>
          )}
          {!!magazine.videoUrl && (
            <WContainer variant="sm">
              <div className={styles.content}>
                <EditableVideo
                  item={{
                    provider: 'youtube',
                    videoId: magazine.videoUrl,
                    autoplay: false,
                    muted: false,
                    loop: false,
                  }}
                  className={styles.video}
                />
              </div>
            </WContainer>
          )}
        </div>
        <Carousel
          item={{
            children: magazine.gallery.map((x) => ({
              image: x.imageUrl,
              imageAlt: x.imageAlt,
            })),
          }}
          className={styles.carousel}
        />

        <div className={styles.container}>
          {!!magazine.descriptionFooter && (
            <WContainer variant="sm">
              <div className={styles.content}>
                {!!magazine.descriptionFooter && (
                  <div
                    className={styles.description}
                    dangerouslySetInnerHTML={{ __html: magazine.descriptionFooter }}
                  />
                )}
              </div>
            </WContainer>
          )}
        </div>

        <ProdottiSection
          refId={'collections'}
          items={magazine.magazinecollezioni.map((i) => ({
            ...i,
            listingImage: i?.listingImage
              ? {
                  url: i.listingImage.url,
                  id: i.listingImage.id,
                }
              : undefined,
            brand: {
              nome: i.brand.nome,
              logoTransparent: i.brand.logoTransparent,
            },
          }))}
          item={{
            name: t('Collezioni utilizzate nel progetto'),
          }}
          theme="neutral10"
          className={styles.collezioni}
        />
        <ArticoliSection magazines={magazine.correlati} theme="white" />
        <Prefooter />
      </main>
    </Page>
  )
}

export default MagazineDetailTemplate
